<template>
<crud-layout :title="title" :subtitle="subtitle">

        <template v-slot:list>
            <reporte-stock-list 
                       ref="list"
                       @update="update"
                       @delete="remove"
                       @show="show"
            
            />
        </template>
        
         <add-button v-if="$store.getters.hasPermission('REPORTESTOCK_CREATE')" @click="create"></add-button>
      
        <reporte-stock-create v-if="creating" 
                        :open="creating"
                        v-on:itemCreated="onItemCreated" 
                        v-on:close="creating=false" 
        />
        
        <reporte-stock-update v-if="updating" 
                        :open="updating"
                        :item="itemToEdit" 
                        v-on:itemUpdated="onItemUpdated" 
                        v-on:close="updating=false" 
        />
          
        <reporte-stock-show v-if="showing" 
                           :open="showing" 
                           :item="itemToShow"  
                           v-on:close="showing=false" 
         />

        <reporte-stock-delete v-if="deleting" 
                         :open="deleting"
                         :item="itemToDelete"  
                         v-on:itemDeleted="onItemDeleted" 
                         v-on:close="deleting=false" 
        />

        <snackbar v-model="flash"/>

</crud-layout>
</template>

<script>
    
    import ReporteStockCreate from "../ReporteStockCreate";
    import ReporteStockUpdate from "../ReporteStockUpdate";
    import ReporteStockDelete from "../ReporteStockDelete";
    import ReporteStockShow from "../ReporteStockShow";
    import ReporteStockList from "../ReporteStockList";
    
     import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"
     
    export default {
        name: "ReporteStockCrud",
        components: {
            CrudLayout, AddButton, Snackbar,
            ReporteStockCreate, 
            ReporteStockUpdate, 
            ReporteStockDelete, 
            ReporteStockShow,
            ReporteStockList
        },
        data() {
            return {
                title: 'cobrox.reporteStock.title',
                subtitle: 'cobrox.reporteStock.subtitle',
                flash: null,
                creating: false,
                updating: false,
                deleting: false,
                showing: false,
                itemToEdit: null,
                itemToDelete: null,
                itemToShow: null,
            }
        },
        methods: {
            //On
            onItemCreated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.created")
            },
            onItemUpdated() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.updated")
            },
            onItemDeleted() {
                this.$refs.list.fetch()
                this.flash= this.$t("common.deleted")
            },
            //Open
            create() {
                this.creating = true
            },
            update(item) {
                this.updating = true
                this.itemToEdit = item
            },
            show(item) {
                this.showing = true
                this.itemToShow = item
            },
            remove(item) {
                this.deleting = true
                this.itemToDelete = item
            }
        }
        
    }
</script>


